import { render, staticRenderFns } from "./MiVendedor.vue?vue&type=template&id=1a79b874"
import script from "./MiVendedor.vue?vue&type=script&lang=js"
export * from "./MiVendedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports